import { useEffect, useState } from "react"
import { useCustomQuery } from "./useCustomQuery"
import { useQuery, useQueryClient } from "@tanstack/react-query"
import { fetchCustomers } from "@/api/customerService"

export const useCustomers = ({
  currentPage = 1,
  perPage = 30,
  searchQuery = "",
}) => {
  const queryClient = useQueryClient()
  const [page, setPage] = useState(currentPage)

  // Fetch customers data using react-query
  const { data, isLoading, isError } = useQuery({
    queryKey: ["customers", page, perPage, searchQuery],
    queryFn: ({ signal }) =>
      fetchCustomers({ page, perPage, searchQuery }, signal),
  })

  return {
    customers: data?.data?.data || [],
    isLoading,
    isError,
    setPage,
  }
}
